<div class="title" *ngIf="isDataCustomTitle; else defaultTitle">
  <h1 mat-dialog-title>{{ data.titleKey | translate }}</h1>
</div>

<ng-template #defaultTitle>
  <div class="are-you-sure title">
    <h1 mat-dialog-title>{{ 'commonPhrases.areYouSure' | translate }}</h1>
  </div>
</ng-template>

<ng-container *ngIf="isDataSubtitle">
  <p class="subtitle">{{ data.subtitleKey | translate }}</p>
</ng-container>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">{{ 'commonPhrases.no' | translate }}</button>
  <button mat-button color="primary" [mat-dialog-close]="true">{{ 'commonPhrases.yes' | translate }}</button>
</mat-dialog-actions>

